import { Component, OnInit } from '@angular/core';

import { Deslocamento } from "../shared/deslocamento.model";
import {deslocamentosModuleName, statusDeslocamentos} from "../shared/data.service";
import { DeslocamentoApiService } from "../shared/deslocamento-api.service";
import { UtilService } from "../../../shared/services/util.service";
import {DeslocamentoService} from "../shared/deslocamento.service";
import {FuncionarioService} from "../../../recursos-humanos/funcionarios/funcionario.service";
import {FuncionarioApiService} from "../../../recursos-humanos/funcionarios/funcionario-api.service";
import {AutoCompleteService} from "../../../shared/components/autocomplete/autocomplete.service";
import {viagensModuleName} from "../../shared/data.service";
import {DestinoApiService} from "../../destinos/shared/destino-api.service";
import {FrotasService} from "../../../bens/frotas/shared/frota.service";
import {FrotaApiService} from "../../../bens/frotas/shared/frota-api.service";
import {MotoristaApiService} from "../../../recursos-humanos/motoristas/shared/motorista-api.service";
import {MotoristaService} from "../../../recursos-humanos/motoristas/shared/motorista.service";
import {destinosQuery} from "../../destinos/shared/data.service";
import {motoristasQuery} from "../../../recursos-humanos/motoristas/shared/data.service";
import {frotasQuery} from "../../../bens/frotas/shared/data.service";
import {DeslocamentoNavigationService} from "../shared/deslocamento-navigation.service";
import set = Reflect.set;

@Component({
    template: require('./deslocamento-calendar.component.html'),
    styles: [require('./deslocamento-calendar.component.css')]
})
export class DeslocamentoCalendarComponent implements OnInit {
    list: Deslocamento[] = [];
    loading: boolean = true;
    showDisabled: boolean = false;
    deslocamentosModuleName: any = deslocamentosModuleName;
    module: any = viagensModuleName;

    statusSearch: any = {};
    statusList: any[] = [];
    destinoSearch: any = {};
    destinoSelectId: string = 'destino';
    destinoQuery: any = {};
    frotaSearch: any = {};
    frotaSelectId: string = 'frota';
    frotaQuery: any = {};
    motoristaSearch: any = {};
    motoristaSelectId: string = 'motorista';
    motoristaQuery: any = {};

    constructor(
        private _deslocamentosApiService: DeslocamentoApiService,
        private _deslocamentoService: DeslocamentoService,
        private _deslocamentoNavigationService: DeslocamentoNavigationService,
        private _utilService: UtilService,

        private _funcionarioService: FuncionarioService,
        private _funcionarioApiService: FuncionarioApiService,
        private _destinoApiService: DestinoApiService,
        private _frotaService: FrotasService,
        private _frotaApiService: FrotaApiService,
        private _motoristaApiService: MotoristaApiService,
        private _motoristaService: MotoristaService,
        private _autocompleteService: AutoCompleteService
    ) { }

    ngOnInit() {
        this.destinoQuery = this._utilService.cloneObject(destinosQuery);
        this.motoristaQuery = this._utilService.cloneObject(motoristasQuery);
        this.frotaQuery = this._utilService.cloneObject(frotasQuery);

        this.getStatus();
        this.clickClearSearch();

        this.createCalendar();
    }

    changeStatus() {
        this.queryMovimentacoes();
    }

    clickClearSearch() {
        this.statusSearch = this.statusList[1];

        this.frotaSearch = {};
        this.destinoSearch = {};
        this.motoristaSearch = {};

        this._autocompleteService.setValueOnSelect2(null, "frota");
        this._autocompleteService.setValueOnSelect2(null, "motorista");
        this._autocompleteService.setValueOnSelect2(null, "destino");

        this.queryMovimentacoes();
    }

    getDestinoObject(object: any) {
        this.destinoSearch = object;
        this.queryMovimentacoes();
    }

    getFrotaObject(object: any) {
        this.frotaSearch = object;
        this.queryMovimentacoes();
    }

    frotaTemplateResult = (function(state: any) {
        let template: any = this._frotaService.templateResult(state, false);
        return template;
    }.bind(this));

    getMotoristaObject(object: any) {
        this.motoristaSearch = object;
        this.queryMovimentacoes();
    }

    motoristaTemplateResult = (function(state: any) {
        let template: any = this._motoristaService.templateResult(state, false);
        return template;
    }.bind(this));

    private queryMovimentacoes() {
        let query: any = {"where":{}};

        if (this.statusSearch.Key) {
            if (this.statusSearch.Key === -1) {
                const statusAprovado = this._deslocamentoService.getStatusAprovado();
                const statusSolicitado = this._deslocamentoService.getStatusSolicitado();
                const or = {or: [{status: statusAprovado}, {status: statusSolicitado}]};
                if (query.where.and) {
                    query.where.and.push(or);
                } else {
                    query.where.and = [or];
                }
            } else {
                query.where.status = this.statusSearch.Key;
            }
        }

        if (this.destinoSearch.id) {
            query.where.destinoId = this.destinoSearch.id;
        }

        if (this.motoristaSearch.id) {
            query.where.motoristaDesignadoId  = this.motoristaSearch.id;
        }

        if (this.frotaSearch.id) {
            query.where.bemId = this.frotaSearch.id;
        }

        this.getMovimentacoes(query);
    }

    private getMovimentacoes(query: any) {
        this.loading = true;
        this._deslocamentosApiService.onGetByFilter(query, this.onDone);
    }

    private onDone = (function(Response: any) {
        if (!Response.error)  {
            let x: number, lenX: number,
                eItem: any,
                events: any[] = [];
            for (x = 0, lenX = Response.length; x < lenX; x++) {
                Response[x].tipo = this._deslocamentoService.getTipo(Response[x].tipo);
                Response[x].status = this._deslocamentoService.getStatus(Response[x].status);
                eItem = this.calendarEvents(Response[x]);
                events.push(eItem);
            }

            this.list = events;
            this.setCalendarEvents(events);
        }
        this.loading = false;
    }.bind(this));

    private getStatus() {
        let list: any[] = this._utilService.cloneObject(statusDeslocamentos);
        let statusAprovado: any = this._deslocamentoService.getStatusAprovado();
        let statusSolicitado: any = this._deslocamentoService.getStatusSolicitado();

        statusAprovado = this._deslocamentoService.getStatus(statusAprovado);
        statusSolicitado = this._deslocamentoService.getStatus(statusSolicitado);

        list.unshift({Key: -1, Value: 'Ativos ('+ statusAprovado.Value + ' e '+ statusSolicitado.Value + ')'});
        list.unshift({Key: null, Value: '— Status —'});
        this.statusList = list;
        this.statusSearch = this.statusList[1];
    }

    private createCalendar() {
        let c: any = this._deslocamentoNavigationService;

        $('#calendar').fullCalendar({
            header: {
                left: 'prev,next today',
                center: 'title',
                right: 'month,basicWeek,basicDay'
            },
            locale: 'pt-br',
            height: 'auto',
            events: [],
            timeFormat: 'H:mm',
            eventRender: function(event, element) {
                var t: any = element.find('.fc-title');
                t.html(t.text());
            },
            eventClick: function(calEvent, jsEvent, view) {
                c.goToDetail(calEvent.id);
            }
        });

    }

    private setCalendarEvents(events: any) {
        $('#calendar').fullCalendar('removeEventSources');
        $('#calendar').fullCalendar('addEventSource', events);
    }

    private calendarEvents(item: any) {
        let tipo: string = '',
            motorista: string = '',
            destino: string = '',
            status: string = '',
            title;

        if (item.tipo) {
            tipo = item.tipo.Value;
        }
        if (item.status) {
            status = " - " + item.status.Value + "<br />";
        }
        if (item.destino){
            destino = "Destino: " + item.destino.destino + "<br />";
        }
        if (item.motoristaDesignado) {
            if (item.motoristaDesignado.funcionario) {
                if (item.motoristaDesignado.funcionario.pessoa) {
                    motorista = "Motorista: " + item.motoristaDesignado.funcionario.pessoa.nome;
                }
            }
        }

        title = tipo + "" + status + "" + destino + "" + motorista;

        let event: any = {
            id: item.id,
            title: title,
            start: item.dataHoraPrevistaSaida,
            end: item.dataHoraPrevistaRetorno,
            color: '#4C87FF',
            textColor: '#FFFFFF'
        };

        return event;
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/deslocamentos/deslocamento-calendar/deslocamento-calendar.component.ts
 **/